import React, { useState } from 'react'
import { Panel, Row, Col, Icon, Toggle, Whisper, Button, Tooltip } from 'rsuite'
import InputForm from '../../components/forms/input/InputForm'
import InputSelectForm from '../../components/forms/input/InputSelectForm'
import { Controller, useForm } from 'react-hook-form'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import TragetArea from './TragetArea'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import PanalLoadingTemplate from '../loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import InputMultiSelectForm from '../../components/forms/input/InputMultiSelectForm'
import { isValidators } from '../../utils/ValidatorUtils'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'

export default function SearchWidget({
  schema,
  isLoading,
  bordered = true,
  shaded = true,
  hideHeader = false,
  onSearch = () => {},
  onCancel = () => {},
}) {
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const [showMore, setShowMore] = useState()

  const buttonMoreText = 'เงื่อนไขค้นหาเพิ่มเติม'

  const handleClickShow = () => {
    setShowMore(!showMore)
  }

  const handleSearch = (data) => {
    console.log('handleSearch : ', data)
    let request = {
      projetctCode: data.projetctCode || '',
      projectName: data.projectName || '',
      contractCode: data.contractCode || '',
      budgetYear: data.budgetYear || '',
      department: data.department || '',
      coordinator: data.coordinator || '',
      projectEndDate: data.projectEndDate || '',
      issue: data.issue?.join(',') || '',
      operationArea: data.operationArea?.join(',') || '',
      selfProject: data.selfProject == undefined ? true : data.selfProject,

      grentreeFirstName: data.grentreeFirstName || '',
      grentreeLastName: data.grentreeLastName || '',
      grentreeEmail: data.grentreeEmail || '',
      grentreeIdCard: data.grentreeIdCard || '',
      grentreeTelephone: data.grentreeTelephone || '',

      responsinatorFirstName: data.responsinatorFirstName || '',
      responsinatorLastName: data.responsinatorLastName || '',
      responsinatorEmail: data.responsinatorEmail || '',
      responsinatorIdCard: data.responsinatorIdCard || '',
      responsinatorTelephone: data.responsinatorTelephone || '',

      organizationName: data.organizationName || '',
      organizationTaxNo: data.organizationTaxNo || '',
    }
    console.log('request : ', request)
    onSearch(request)
  }

  const handleCancel = () => {
    // setValue(schema.projetctCode, '')

    onCancel()
  }

  const tooltip = (
    <Tooltip>
      {showMore ? (
        <>
          <div style={{ marginTop: 5 }}>คลิกเพื่อซ่อนเงื่อนไขการค้นหาเพิ่มเติม</div>
        </>
      ) : (
        <>
          <div style={{ marginTop: 5 }}>คลิกเพื่อแสดงเงื่อนไขการค้นหาเพิ่มเติม</div>
        </>
      )}
    </Tooltip>
  )

  if (!schema) {
    return <PanalLoadingTemplate />
  }

  return (
    <Panel
      header={hideHeader ? ' ' : schema?.header || 'ค้นหา'}
      bordered={bordered}
      shaded={shaded}
      //collapsible
      //defaultExpanded
      style={{ marginTop: 10, marginBottom: 10 }}
    >
      {schema && (
        <>
          <Row style={{ marginTop: -10 }}>
            {schema.projetctCode && (
              <Col lg={4} md={6} sm={8} xs={24}>
                <InputForm
                  schema={schema.projetctCode}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Col>
            )}
            {schema.contractCode && (
              <Col lg={4} md={6} sm={8} xs={24}>
                <InputForm
                  schema={schema.contractCode}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Col>
            )}

            {schema.projectName && (
              <Col lg={8} md={8} sm={10} xs={24}>
                <InputForm
                  schema={schema.projectName}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Col>
            )}

            {schema.selfProject && (
              <Col lg={3} md={5} sm={8} xs={24}>
                <Controller
                  key={schema.selfProject.name}
                  name={schema.selfProject.name}
                  control={control}
                  rules={isValidators(schema.selfProject.validators)}
                  defaultValue={schema.selfProject.value}
                  render={(prop) => {
                    return (
                      <div style={{ marginTop: 35 }}>
                        <Toggle
                          size="lg"
                          checked={prop.value}
                          checkedChildren={<Icon icon="check" />}
                          unCheckedChildren={<Icon icon="close" />}
                          onChange={(value) => {
                            console.log('selfProject : ', value)
                            prop.onChange(value)
                          }}
                        />
                        <label style={{ marginLeft: 10 }}>{schema.selfProject.label}</label>
                      </div>
                    )
                  }}
                />
              </Col>
            )}

            <Col lg={5} md={7} sm={8} xs={24} style={{ textAlign: 'center' }}>
              <div style={{ marginTop: 35 }}>
                {schema.button.search && (
                  <SearchButton onClick={handleSubmit(handleSearch)} disabled={isLoading}>
                    {schema.button.search}
                  </SearchButton>
                )}
                {schema.button.cancel && (
                  <CancelButton
                    onClick={() => {
                      handleCancel()
                    }}
                    // disabled={isLoading}
                  >
                    {schema.button.cancel}
                  </CancelButton>
                )}
              </div>
            </Col>
          </Row>

          {!showMore && (
            <Row style={{ marginTop: 10 }} id="showMore">
              <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'center' }}>
                <hr style={{ borderTop: '2px solid #2da888 !important' }} />
                <div
                  style={{ position: 'relative', fontSize: 12, marginTop: -38, fontWeight: 'bold' }}
                >
                  <Whisper
                    placement="bottom"
                    controlId="control-id-hover"
                    trigger="hover"
                    speaker={tooltip}
                  >
                    <Button
                      appearance="primary"
                      style={{
                        backgroundColor: '#fff',
                        color: '#2da888',
                        fontSize: '12px !important',
                        fontWeight: 'bold',
                      }}
                      onClick={handleClickShow}
                    >
                      <Icon icon="angle-double-down" /> {`  ${buttonMoreText} `}{' '}
                      <Icon icon="angle-double-down" />
                    </Button>
                  </Whisper>
                </div>
                <br />
              </Col>
            </Row>
          )}

          {showMore && (
            <>
              <Row>
                {schema.budgetYear && (
                  <Col lg={4} md={6} sm={8} xs={24}>
                    <InputSelectForm
                      schema={schema.budgetYear}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                    />
                  </Col>
                )}
                {schema.department && (
                  <Col lg={4} md={6} sm={8} xs={24}>
                    <InputSelectForm
                      schema={schema.department}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                    />
                  </Col>
                )}

                {schema.coordinator && (
                  <Col lg={4} md={6} sm={8} xs={24}>
                    <InputSelectForm
                      schema={schema.coordinator}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                    />
                  </Col>
                )}
                {schema.projectEndDate && (
                  <Col lg={4} md={6} sm={8} xs={24}>
                    <Row>
                      <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                        {schema.projectEndDate.label}
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5 }}>
                        <Controller
                          key={schema.projectEndDate.name}
                          name={schema.projectEndDate.name}
                          control={control}
                          render={(props) => {
                            return (
                              <DatePickerCustom
                                {...props}
                                placement="auto"
                                onChange={(value) => {
                                  props.onChange(value)
                                }}
                              />
                            )
                          }}
                        />
                      </Col>
                    </Row>
                  </Col>
                )}
              </Row>

              <Row>
                {schema.issue && (
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <InputMultiSelectForm
                      schema={schema.issue}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                    />
                  </Col>
                )}

                {schema.operationArea && (
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <Row style={{ marginLeft: 0 }}>
                      <Col style={{ marginTop: 15 }}>{schema.operationArea.label}</Col>
                      <Col>
                        <TragetArea
                          schema={schema.operationArea}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                        />
                      </Col>
                    </Row>
                  </Col>
                )}
              </Row>
              {/* {userType != 'user' && (
                <> */}
              <Row>
                <Col
                  lg={6}
                  md={8}
                  sm={12}
                  xs={24}
                  style={{
                    color: '#2da888',
                    marginTop: 10,
                  }}
                >
                  <b>
                    <u>ผู้รับผิดชอบโครงการ</u>
                  </b>
                </Col>
              </Row>

              <Row>
                <Col lg={4} md={6} sm={8} xs={24}>
                  <InputForm
                    schema={schema.responsinatorFirstName}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>
                <Col lg={4} md={6} sm={8} xs={24}>
                  <InputForm
                    schema={schema.responsinatorLastName}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>
                <Col lg={4} md={6} sm={8} xs={24}>
                  <InputForm
                    schema={schema.responsinatorIdCard}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>
                <Col lg={4} md={6} sm={8} xs={24}>
                  <InputForm
                    schema={schema.responsinatorTelephone}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>
                <Col lg={4} md={6} sm={8} xs={24}>
                  <InputForm
                    schema={schema.responsinatorEmail}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>
              </Row>

              <Row style={{ marginTop: 30 }}>
                <Col
                  lg={6}
                  md={8}
                  sm={12}
                  xs={24}
                  style={{
                    color: '#2da888',
                  }}
                >
                  <b>
                    <u>ผู้รับทุน</u>
                  </b>
                </Col>
              </Row>

              <Row>
                <Col lg={4} md={6} sm={8} xs={24}>
                  <InputForm
                    schema={schema.grentreeFirstName}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>
                <Col lg={4} md={6} sm={8} xs={24}>
                  <InputForm
                    schema={schema.grentreeLastName}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>
                <Col lg={4} md={6} sm={8} xs={24}>
                  <InputForm
                    schema={schema.grentreeIdCard}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>{' '}
                <Col lg={4} md={6} sm={8} xs={24}>
                  <InputForm
                    schema={schema.grentreeTelephone}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>
                <Col lg={4} md={6} sm={8} xs={24}>
                  <InputForm
                    schema={schema.grentreeEmail}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>
              </Row>

              <Row style={{ marginTop: 30 }}>
                <Col
                  lg={6}
                  md={8}
                  sm={12}
                  xs={24}
                  style={{
                    color: '#2da888',
                  }}
                >
                  <b>
                    <u>องค์กรผู้รับทุน</u>
                  </b>
                </Col>
              </Row>

              <Row>
                <Col lg={6} md={8} sm={12} xs={24}>
                  <InputForm
                    schema={schema.organizationName}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>
                <Col lg={6} md={8} sm={12} xs={24}>
                  <InputForm
                    schema={schema.organizationTaxNo}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>
              </Row>
              {/* </>
              )} */}

              <Row style={{ marginTop: 10 }} id="showMore">
                <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'center' }}>
                  <hr style={{ borderTop: '2px solid #2da888 !important' }} />
                  <div
                    style={{
                      position: 'relative',
                      fontSize: 12,
                      marginTop: -38,
                      fontWeight: 'bold',
                    }}
                  >
                    <Whisper
                      placement="bottom"
                      controlId="control-id-hover"
                      trigger="hover"
                      speaker={tooltip}
                    >
                      <Button
                        appearance="primary"
                        style={{
                          backgroundColor: '#fff',
                          color: '#2da888',
                          fontSize: '12px !important',
                          fontWeight: 'bold',
                        }}
                        onClick={handleClickShow}
                      >
                        <Icon icon="angle-double-up" /> {` ${buttonMoreText} `}
                        <Icon icon="angle-double-up" />
                      </Button>
                    </Whisper>
                  </div>
                  <br />
                </Col>
              </Row>
            </>
          )}
        </>
      )}

      {isLoading && <OverlayLoader />}
    </Panel>
  )
}
